import React, { useState } from "react";
import {
    Container,
    Typography,
    TextField,
    Button,
    Box,
    FormControl,
    InputLabel,
    Input,
    FormGroup,
    FormHelperText,
} from "@mui/material";
import { ungzip } from "pako";
import untar from "js-untar";

function WelcomePage(props) {
    const [url, setUrl] = useState("");
    const [uploadedFileName, setUploadedFileName] = useState("");
    const [uploadedFileJSON, setUploadedFileJSON] = useState(null);

    const handleUrlChange = (e) => {
        setUrl(e.target.value);
    };

    const handleFileUpload = async (e) => {
        const file = e.target.files[0];
        if (file && file.name.endsWith(".tgz")) {
            // Handle file upload here
            console.log("Uploading:", file);

            // Read the file contents and ungzip
            const fileReader = new FileReader();
            fileReader.onload = async (e) => {
                try {
                    const arrayBuffer = e.target.result;
                    const ungzipData = ungzip(new Uint8Array(arrayBuffer));

                    // Parse the tar archive and find the .json file
                    const files = await untar(ungzipData.buffer);

                    // Find the JSON file
                    const jsonFile = files.find((file) => file.name.endsWith(".json"));

                    if (!jsonFile) {
                        throw new Error("No .json file found in the .tgz archive");
                    }

                    // Parse the JSON content
                    const playbookJSON = jsonFile.readAsJSON()

                    // Store the JSON and file name in the state
                    setUploadedFileJSON(playbookJSON);
                    setUploadedFileName(jsonFile.name);

                } catch (error) {
                    alert("Error reading the .tgz file");
                    console.error(error);
                }
            };
            fileReader.readAsArrayBuffer(file);
        } else {
            alert("Please upload a .tgz file");
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (url) {
            // Handle URL submission here
            console.log("Submitted URL:", url);
            props.onUrlSubmit(url);
        } else if (uploadedFileJSON) {
            // Pass the JSON to the PlaybookViewer
            props.onFileUpload(uploadedFileJSON);
        } else {
            alert("Please enter a URL or upload a playbook .tgz");
        }
    };

    return (
        <Container maxWidth="sm" style={{ marginTop: "2rem" }}>
            <Typography variant="h4" component="h1" gutterBottom>
                Splunk SOAR Playbook Explorer
            </Typography>
            <Box component="form" onSubmit={handleSubmit}>
                <TextField
                    label="Enter a URL"
                    variant="outlined"
                    fullWidth
                    value={url}
                    onChange={handleUrlChange}
                    style={{ marginBottom: "1rem" }}
                />
                <FormGroup>
                    <FormControl fullWidth variant="outlined">
                        <InputLabel htmlFor="playbook-file">
                        </InputLabel>
                        <Input
                            id="playbook-file"
                            type="file"
                            inputProps={{ accept: ".tgz" }}
                            onChange={handleFileUpload}
                            style={{ display: "none" }}
                        />
                    </FormControl>
                    <label htmlFor="playbook-file">
                        <Button
                            variant="outlined"
                            color="primary"
                            component="span"
                            style={{ marginTop: "1rem" }}
                        >
                            Choose File
                        </Button>
                    </label>
                    <FormHelperText>
                        {uploadedFileName ? `Uploaded: ${uploadedFileName}` : "Choose a .tgz file to upload"}
                    </FormHelperText>
                </FormGroup>
                <Button
                    variant="contained"
                    color="primary"
                    type="submit"
                    fullWidth
                    style={{ marginTop: "1rem" }}
                >
                    Submit
                </Button>
            </Box>
        </Container>
    );
}

export default WelcomePage;
